import * as React from "react"
import type { SVGProps } from "react"
const SvgSlideshow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M2 15.14v-6q0-.82.59-1.41A2 2 0 0 1 4 7.14q.82 0 1.41.59.6.6.59 1.41v6q0 .83-.59 1.41a2 2 0 0 1-1.41.6q-.82 0-1.41-.6a2 2 0 0 1-.59-1.4m7 4q-.82 0-1.41-.58A2 2 0 0 1 7 17.13v-10q0-.82.59-1.41A2 2 0 0 1 9 5.14h6q.83 0 1.41.59.6.6.59 1.41v10q0 .82-.59 1.42a2 2 0 0 1-1.41.58zm9-4v-6q0-.82.59-1.41a2 2 0 0 1 1.41-.6q.83 0 1.41.59.6.6.59 1.41v6q0 .83-.59 1.41a2 2 0 0 1-1.41.6q-.83 0-1.41-.6a2 2 0 0 1-.59-1.4m-9 2h6v-10H9z" />
  </svg>
)
export default SvgSlideshow
